import type { MessageDescriptor } from 'react-intl';
import clsx from 'clsx';
import { FormattedError } from '../formatted/index.ts';

export interface InputContainerProps {
  children?: React.ReactNode;
  cornerText?: React.ReactNode;
  error?: React.ReactNode | MessageDescriptor;
  helpText?: React.ReactNode;
  label?: React.ReactNode;
}

export function InputContainer({
  children,
  cornerText,
  error,
  helpText,
  label
}: InputContainerProps) {
  const errorMessage =
    error && typeof error !== 'boolean' ? <FormattedError error={error} /> : undefined;

  return (
    <div>
      {label || cornerText ? (
        <div className="mb-1 flex justify-between">
          {label ? (
            <label className="block text-sm font-medium text-gray-700">{label}</label>
          ) : (
            <span />
          )}
          {cornerText && <span className="text-sm text-gray-500">{cornerText}</span>}
        </div>
      ) : undefined}
      {children}
      {(!!errorMessage || !!helpText) && (
        <p className={clsx('mt-2 text-sm', errorMessage ? 'text-red-600' : 'text-gray-500')}>
          {errorMessage || helpText}
        </p>
      )}
    </div>
  );
}
